import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ILoggerProvider,
  LOGGING_PROVIDER,
} from '@nibtravel/shared/util/constants';
import { GTM_PROVIDER, IGtmProvider } from '@nibtravel/shared/util/gtm';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { LoadAppConfig } from './state/app-config.actions';

export const InitializerFactory =
  (service: AppInitializerService): (() => Observable<void>) =>
  () =>
    service.init();

@Injectable()
export class AppInitializerService {
  constructor(
    private store: Store,
    @Inject(LOGGING_PROVIDER) private logger: ILoggerProvider,
    @Inject(GTM_PROVIDER) private gtmProvider: IGtmProvider
  ) {}

  init(): Observable<any> {
    return this.store.dispatch(new LoadAppConfig()).pipe(
      tap((state) => {
        this.logger.init(state.appConfig.sumo);
        this.gtmProvider.init(state.appConfig.gtm, state.appConfig.ga4TagId);
      })
    );
  }
}
